"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanFieldType = void 0;
const tslib_1 = require("tslib");
const HasValueWidget_1 = tslib_1.__importDefault(require("../widget/HasValueWidget"));
const ImageWidget_1 = tslib_1.__importStar(require("../widget/ImageWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
// Component rendered in the user interface
// <div style="display: flex; flex-direction: column">
//   <image-widget>[aBoolean?]</image-widget>
//   <span>{label}</span>
//   <span class="sr-only">checkbox/radioknap markeret/ikke markeret</span>
// </div>
class ReadOnlyBooleanField extends HasValueWidget_1.default {
    constructor({ value = false, label, booleanType = BooleanFieldType.BOOLEAN }) {
        super();
        this.booleanFieldValue = { value, label, booleanType };
        this.element = document.createElement("div");
        this.element.classList.add("boolean-field");
        this.valueElement = new ImageWidget_1.default({
            alt: "",
            imageDimension: ImageWidget_1.ImageDimensions.L,
            src: this.getImageSrc()
        });
        this.labelElement = document.createElement("span");
        this.hiddenCheckedElement = document.createElement("span");
        this.hiddenCheckedElement.classList.add("sr-only");
        this.setValue(value);
        this.setLabel(label);
        this.element.appendChild(this.valueElement.element);
        this.element.appendChild(this.labelElement);
        this.element.appendChild(this.hiddenCheckedElement);
    }
    setLabel(label) {
        this.booleanFieldValue.label = label;
        this.labelElement.textContent = label;
    }
    getValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        this.booleanFieldValue.value = this.value;
        this.valueElement.setSrc(this.getImageSrc());
        this.hiddenCheckedElement.textContent = this.getCheckedValueText();
    }
    clearValue() {
        super.clearValue();
        this.booleanFieldValue.value = false;
        this.valueElement.setSrc(this.getImageSrc());
        this.hiddenCheckedElement.textContent = this.getCheckedValueText();
    }
    getImageSrc() {
        const booleanType = this.booleanFieldValue.booleanType;
        if (booleanType) {
            if (booleanType === BooleanFieldType.CHECKBOX) {
                return this.booleanFieldValue.value
                    ? fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.READONLY_CHECKMARK_CHECKED)
                    : fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.READONLY_CHECKMARK_UNCHECKED);
            }
        }
        return this.booleanFieldValue.value
            ? fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.CHECKMARK)
            : fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.DISABLED);
    }
    getCheckedValueText() {
        const booleanType = this.booleanFieldValue.booleanType;
        const checkedText = this.booleanFieldValue.value
            ? "markeret"
            : "ikke markeret";
        return `${booleanType} ${checkedText}`;
    }
}
exports.default = ReadOnlyBooleanField;
var BooleanFieldType;
(function (BooleanFieldType) {
    BooleanFieldType["BOOLEAN"] = "felt";
    BooleanFieldType["RADIO"] = "radioknap";
    BooleanFieldType["CHECKBOX"] = "checkbox";
})(BooleanFieldType = exports.BooleanFieldType || (exports.BooleanFieldType = {}));
//# sourceMappingURL=ReadOnlyBooleanField.js.map